<p-card class="widget" [ngClass]="{ 'widget--draggable': isEditing }">
  <div class="widget__content">
    @if (isLoading) {
      <p-progress-spinner class="widget__loader" strokeWidth="6" />
    }
    @if (component) {
      <ng-container
        [ngComponentOutlet]="component"
        [ngComponentOutletInputs]="{
          isEditing: isEditingConfiguration,
          configuration: widget!.configuration!,
          loadingChange: loadingStateChange,
          configurationDelete,
          configurationChange,
        }"></ng-container>
    }
  </div>
</p-card>
